module.exports = __webpack_public_path__ + "img/logo-icon.4f2ad4f8.svg";